<template>
  <div class="tab-table">
    <simple-table
      category="models"
      :columns="columns"
      :loading="loading"
      :error="error"
      :list="list"
      @rowClick="rowClick"
      @fetch="handleFetch"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/common/SimpleTable';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'models-table',

  components: {
    SimpleTable,
  },

  data() {
    return {
      columns: [
        { label: 'Название', name: 'title', width: '25%' },
        { label: 'Файлы руководств', name: 'manual_urls', width: '55%' },
        { label: 'Изображение', name: 'image_url', width: '55%' },
      ],
    };
  },

  watch: {
    params: {
      deep: true,
      handler: function() {
        this.fetch();
      },
    },
  },

  computed: {
    ...mapGetters({
      loading: 'models/loading',
      params: 'models/params',
      error: 'models/error',
      list: 'models/list',
    }),
  },

  methods: {
    ...mapActions({
      fetch: 'models/fetch',
    }),

    rowClick(id) {
      this.$router.push({
        name: `models-item`,
        params: {
          id,
        },
      });
    },

    handleFetch() {
      this.fetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
